import React from 'react';
import ReactJson from 'react-json-view';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import Card from '@components/Card';
import InputStandard from '@components/InputStandard';
import useAPI from '@hooks/useAPI';
import Button from '@shared/Button';
import Modal from '@shared/Modal';
import Spinner from '@shared/Spinner';
import { ReactComponent as DownArrowIcon } from '@src/assets/escher/icons/arrow-drop-down.svg';
import { ReactComponent as UpArrowIcon } from '@src/assets/escher/icons/arrow-drop-up.svg';
import { ReactComponent as FileCopy } from '@src/assets/escher/icons/file-copy.svg';
import ButtonsRow from '@styled/Containers/ButtonsRow';
import P from '@styled/Elements/P';
import UpdateList from '@utils/updateList';
import { copyToClipboard } from '@utils/utils';

const ExpandBtn = styled(Button)`
  background-color: ${props => props.theme.enigmaWhite};
  border-radius: 20px auto;
  border: 1px solid ${props => props.theme.primary};
  color: ${props => props.theme.primary};
  display: inline-block;
  font-family: 'GT Mono', monospace;
  font-size: 12px;
  margin-top: 20px;
  text-transform: uppercase;
  &:hover {
    background-color: ${props => props.theme.primary};
    color: ${props => props.theme.enigmaWhite};
    border: 1px solid ${props => props.theme.primary};
  }
`;

const Container = styled.div`
  width: 800px;
  height: 80vh;
  word-break: break-all;
  overflow: scroll;
`;

const RecallContainer = styled.div`
  padding: 10px 40px;
`;

const CopyToClipboardButton = ({ src }) => {
  const handleCopy = () => {
    copyToClipboard(JSON.stringify(src, null, 2));
    toast.success('Copied recall explanation JSON to clipboard');
  };

  return (
    <Button onClick={handleCopy} color='blue'>
      <FileCopy />
    </Button>
  );
};

const RecallItem = ({ label, src }) => {
  const [expanded, setExpanded] = React.useState(true);
  const toggleExpanded = () => setExpanded(!expanded);

  return (
    <div>
      <h2>
        <span onClick={toggleExpanded}>
          {expanded ? <UpArrowIcon /> : <DownArrowIcon />}
          {label}
        </span>
        &nbsp;
        <CopyToClipboardButton src={src} />
      </h2>
      {expanded && (
        <RecallContainer>
          <ReactJson collapsed={2} src={src} />
        </RecallContainer>
      )}
    </div>
  );
};

export default function RecallModal({ recall_explanation, handleClose }) {
  const data = recall_explanation || {};
  const hasData = data && data.length;
  const [expanded, setExpanded] = React.useState(false);

  const show = e => {
    setExpanded(true);
  };

  const hide = e => {
      setExpanded(false);
  }

  let headerText = "Recall Explanation";
  let entityLabel = "Info";

  return ( 
    <div> <ExpandBtn onClick={show}>
    Show Recall Explanation
    </ExpandBtn>
    <Modal id='modal' toggle={handleClose} open={expanded && hasData}>
      <Card title={headerText} shadow>
        <Container>
          <RecallItem src={recall_explanation} label={entityLabel} />
        </Container>
      </Card>
        <ExpandBtn onClick={hide}>
            Close
        </ExpandBtn>
    </Modal>
    </div> 
  );
}
